/* global BigInt */
// Preserve precise unit prices. Round extended amounts half-up to cents first,
// then ceil to whole shillings so sub-cent residue cannot add a whole shilling.
const decimalParts = value => {
    const [mantissa, exponent = '0'] = String(value ?? 0).toLowerCase().split('e');
    const [whole, fraction = ''] = mantissa.split('.');
    return {integer: BigInt(whole + fraction), scale: fraction.length - Number(exponent)};
};

export const moneyProduct = (price, quantity = 1) => {
    const a = decimalParts(price), b = decimalParts(quantity);
    let integer = a.integer * b.integer;
    const scale = a.scale + b.scale - 2;
    if (scale > 0) {
        const divisor = BigInt(10) ** BigInt(scale);
        const sign = integer < 0 ? -BigInt(1) : BigInt(1);
        integer = sign * ((integer * sign + divisor / BigInt(2)) / divisor);
    } else {
        integer *= BigInt(10) ** BigInt(-scale);
    }
    // BigInt division truncates toward zero; this is already ceiling for negatives.
    const whole = integer > 0 ? (integer + BigInt(99)) / BigInt(100) : integer / BigInt(100);
    return Number(whole);
};

export const roundMoney = value => moneyProduct(value);
